import type { RecordingStatus } from '@/features/rpa/recorder/model/types';
import type { UploadStage } from '@/tauri/rpa-recorder/upload-types';

const RECORDING_STATUS_BY_UPLOAD_STAGE: Partial<Record<UploadStage, RecordingStatus>> = {
  ready: 'ready',
  failed: 'failed',
  polling: 'polling',
};

export function recordingStatusFromUploadStage(stage: UploadStage): RecordingStatus {
  return RECORDING_STATUS_BY_UPLOAD_STAGE[stage] ?? 'uploading';
}
